"use client";

import { SignedIn, SignedOut, UserButton } from "@clerk/nextjs";
import Link from "next/link";
import { Logo } from "@/components/assets/icon/logo";
import { Button } from "@/components/ui/button";

export function HomeV2Navbar() {
  return (
    <header className="sticky top-0 z-50 w-full bg-white/95 backdrop-blur-sm">
      {/* Figma: 1400×51, padding 0 16px */}
      <div className="m-6 mx-auto flex h-[51px] max-w-[1400px] items-center justify-between px-4">
        <Link aria-label="TeleTradie home" className="shrink-0" href="/v2">
          {/* Figma logo: 180×51 */}
          <Logo className="h-[51px] w-[180px]" />
        </Link>

        <nav className="flex items-center gap-[19px]">
          <SignedOut>
            <Button
              asChild
              className="h-[45px] min-w-[130px] rounded-full bg-tt-yellow px-6 font-semibold text-[#2C2C2C] text-lg leading-[1.4] hover:bg-tt-yellow/90"
            >
              <Link href="/v2/login">Login</Link>
            </Button>
            <Button
              asChild
              className="h-[45px] min-w-[130px] rounded-full border-2 border-[#2C2C2C] bg-white px-6 font-semibold text-[#2C2C2C] text-lg leading-[1.4] hover:bg-neutral-50"
              variant="outline"
            >
              <Link href="/v2/login?mode=sign-up">Join us now, free!</Link>
            </Button>
          </SignedOut>

          <SignedIn>
            <Button
              asChild
              className="h-[45px] min-w-[130px] rounded-full bg-tt-yellow px-6 font-semibold text-[#2C2C2C] text-lg leading-[1.4] hover:bg-tt-yellow/90"
            >
              <Link href="/">Go to app</Link>
            </Button>
            <UserButton
              appearance={{
                elements: {
                  avatarBox: "size-10",
                },
              }}
            />
          </SignedIn>
        </nav>
      </div>
    </header>
  );
}
